module.exports = __webpack_public_path__ + "static/img/hqms-4.ac5d1c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hqms/hqms-4.png
// module id = B+BG
// module chunks = 1